import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PlanService } from 'src/app/nutrigenic/services/plan/plan.service';
import { Notify } from 'notiflix/build/notiflix-notify-aio';

@Component({
    selector: 'app-cancel-subscription',
    templateUrl: './cancel-subscription.component.html',
    styleUrls: ['./cancel-subscription.component.scss']
})
export class CancelSubscriptionComponent {
    @Input() orderId: number;
    @Input() cancellationDates: any[] = [];
    @Output() cancelled = new EventEmitter<string>();

    cancellationForm: FormGroup;

    constructor(private fb: FormBuilder, private planService: PlanService) {}

    ngOnInit() {
        this.cancellationForm = this.fb.group({
            cancelDate: ['', [Validators.required]],
            reason: ['', [Validators.required]]
        });
    }

    sendCancelation() {
        if (this.cancellationForm.valid) {
            this.planService.cancelSubscription(
                this.orderId,
                this.cancellationForm.get('reason')?.value,
                this.cancellationForm.get('cancelDate')?.value
            ).subscribe({
                next: () => {
                    const cancelDate = this.cancellationForm.get('cancelDate')?.value;
                    this.cancellationForm.reset();
                    this.cancelled.emit(cancelDate);
                },
                error: (error) => {
                    const msg = error?.message ?? 'Internal error - Could not complete the operation';
                    Notify.failure(msg, { position: 'right-top', timeout: 3000 });
                }
            });
        }
    }
}
